import { createFileRoute } from '@tanstack/react-router';
import { KnowledgeSupervisionPage } from '../../../../features/assistantKnowledge/pages/KnowledgeSupervisionPage';

export const Route = createFileRoute(
  '/_app/assistant/knowledge/$assistantName/$knowledgeId'
)({
  loader: async () => {
    // manifests are fetched and polled by the page component itself
  },
  component: KnowledgeSupervisionPage,
});
